import { Link } from 'react-router-dom';
import { USER_TYPE_CONFIG, REGISTERABLE_USER_TYPES, type UserType } from '@/shared/types/users.types';

export function OtherTypes({ current }: { current: string }) {
    const suggestions = REGISTERABLE_USER_TYPES
        .filter(type => type !== current)
        .map(type => ({
            type,
            label: USER_TYPE_CONFIG[type].label,
            icon: USER_TYPE_CONFIG[type].icon,
            color: `text-${USER_TYPE_CONFIG[type].color}-500`,
        }));

    if (suggestions.length === 0) return null;

    return (
        <div className="mt-8 bg-white rounded-2xl shadow-lg p-5">
            <p className="text-center text-sm font-medium text-gray-600 mb-4">Autres types d'inscription</p>
            <div className="flex flex-wrap justify-center gap-2">
                {suggestions.map(s => (
                    <Link
                        key={s.type}
                        to={`/register/${s.type}`}
                        className="flex flex-col items-center p-3 w-24 border border-gray-100 rounded-xl
                            hover:border-gray-300 hover:bg-gray-50 transition-all text-center"
                    >
                        <i className={`${s.icon} text-xl ${s.color} mb-1`} />
                        <span className="text-xs font-medium text-gray-600">{s.label}</span>
                    </Link>
                ))}
            </div>
        </div>
    );
}
